import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

/**
 * Configuração do Firebase para ambiente de DESENVOLVIMENTO
 * Projeto: controle-financeiro-pwa-467114
 */
const firebaseConfig = {
  apiKey: 'AIzaSyAM00go-FDDgd_CnQqGYqDl54amxEOfRr4',
  authDomain: 'controle-financeiro-pwa-467114.firebaseapp.com',
  projectId: 'controle-financeiro-pwa-467114',
  storageBucket: 'controle-financeiro-pwa-467114.firebasestorage.app',
  messagingSenderId: '949290764368',
  appId: '1:949290764368:web:9bcf31ff480061430ee955'
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
